import React, {useContext, useEffect} from 'react'
import {Modal} from '@/components/Modal'
import {ProductContext} from '../ProductContext'
import {ProductAvailability, computeAmount, computeEarnings} from '../../core/_models'
import {Supplier} from '../../../suppliers/core/_models'
import {TableCard, PricingEvolutionChartCard} from './cards/supplier'
import {CurrentPricingCard, Data} from './cards/supplier/CurrentPricingCard'
import {AvailabilityForm} from './forms/AvailabilityForm'

const Suppliers = () => {
  const {
    product,
    setItemForUpdate,
    setAction,
    action,
    itemForUpdate,
    fetchAvailability,
    availability,
    suppliers
  } = useContext(ProductContext)
  const close = () => {
    setItemForUpdate(undefined)
    setAction(undefined)
  }

  useEffect (() => {
    void(product && fetchAvailability())
  }, [product])

  if (product?.alias) {
    return (<>Not available for product alias</>)
  }

  if (product === undefined) {
    return (<>No product</>)
  }

  const soldPrice = parseFloat(((product.credits || 0)/ product.currencyRate).toFixed(4))
  const pricing = availability?.map((a: ProductAvailability) => {
    const supplier = suppliers.find((s: Supplier) => s._id === a.supplier)
    const priceDigits = supplier?.priceDigits ?? 3
    return {
      label: supplier?.name || 'Unknown',
      amount: computeAmount(a, priceDigits),
      ...computeEarnings(a, soldPrice, priceDigits)
    }
  }) || [] as Data[]

  pricing.push({
    label: 'Public price',
    amount: product?.publicPricing?.amount || 0,
    earnings: null,
    vat: null
  })
  pricing.push({
    label: 'Sold price',
    amount: soldPrice,
    earnings: null,
    vat: null
  })


  return (
    <>
      <TableCard/>
      <div className="row">
        <div className="col-xl-4">
          <CurrentPricingCard data={pricing} />
        </div>
        <div className="col-xl-8">
          <PricingEvolutionChartCard productId={product._id}/>
        </div>
      </div>
      {itemForUpdate && action === 'edit' && (
        <Modal title={`Edit supplier data`} close={close}>
          <AvailabilityForm
            availability={itemForUpdate as ProductAvailability}
            close={close}
          />
        </Modal>
      )}
      {itemForUpdate === null && action === 'add' && (
        <Modal title={`Add supplier data`} close={close}>
          <AvailabilityForm
            close={close}
          />
        </Modal>
      )}
    </>
  )
}

export default Suppliers
